import type { SxProps, Theme } from '@mui/material';
import type React from 'react';

import type {
  SmartReportComponentTypesEnum,
  SmartReportTypeEnum,
} from '@/admins/SmartReports/types';
import type { Portfolio } from '@/types/GraphqlSchema';

export type OnComponentLoadArgs<DataType> = {
  componentId: string;
  slotId?: string;
  data: DataType | null;
};

export type OnComponentLoad<DataType> = (params: OnComponentLoadArgs<DataType>) => void;

export enum ComponentViewMode {
  Edit = 'edit',
  View = 'view',
}

export type ComponentViewProps<DataType> = {
  data: DataType;
  portfolio?: Portfolio;
  sx?: SxProps<Theme> | undefined;
  children?: React.ReactNode;
  mode?: ComponentViewMode.Edit | ComponentViewMode.View;
};

export type UseDataType<DataType> = {
  portfolio: Portfolio;
  persistedData?: DataType | undefined;
  onComponentLoad?: OnComponentLoad<DataType> | undefined;
};

export type ComponentEditProps<DataType> = {
  sx?: SxProps<Theme> | undefined;
  children?: React.ReactNode;
} & UseDataType<DataType>;

export type ComponentDefinition<DataType> = {
  id: string;
  name: string;
  type: SmartReportComponentTypesEnum;
  reportTypes: SmartReportTypeEnum[];
  Thumbnail?: React.ComponentType<ComponentEditProps<DataType> | undefined>;
  Component: React.ComponentType<ComponentEditProps<DataType>>;
  ComponentView: React.ComponentType<ComponentViewProps<DataType>>;
};
